@if (currentWorkflow()) {
  <div
    class="flex items-center justify-between border border-aux-gray-dark p-2.5 pl-4 pr-4"
    [ngClass]="{
      'bg-aux-gray-light': !isLocked(),
      'bg-aux-blue-dark': isLocked(),
    }"
  >
    <div class="flex items-center">
      @if (isLocked()) {
        <aux-icon name="Lock" class="text-white" />
      } @else {
        <aux-icon name="LockOpen" />
      }

      <div class="ml-3">
        @if (isWorkflowNameVisible()) {
          <p
            class="font-bold text-aux-black"
            [ngClass]="{
              'text-aux-black': !isLocked(),
              'text-white': isLocked(),
            }"
          >
            {{ workflowTitle() }}
          </p>
        }
        <p
          class="text-sm"
          [ngClass]="{
            'text-aux-gray-darkest': !isLocked(),
            'text-white': isLocked(),
          }"
        >
          {{ getTitle() }}
        </p>
      </div>
    </div>

    <aux-button
      [disabled]="!hasUserPermissions() || !lockAvailable()"
      [auxTooltip]="getBtnTooltipText()"
      [label]="getBtnLabel()"
      [icon]="getBtnIcon()"
      [variant]="getBtnVariant()"
      (click)="onToggleLockWorkflow()"
      [attr.data-pendo-id]="getBtnDataPendoId()"
    />
  </div>
}
